/* eslint-disable no-unused-vars */
import { useParams } from 'react-router';
import * as S from './CreatePlacementModal.styled';
import { ModalBase, ModalHeader, ModalFooter, CustomInput } from 'components';
import { manageAppsAPI } from 'services/manageApps.service';
import { useComputed, useSignal } from '@preact/signals-react';

const NAME_CHAR_LIMIT = 100;

const CreatePlacementModal = ({ close }) => {
  const { pba_id } = useParams();
  const [createPlacement] = manageAppsAPI.useCreatePlacementMutation();
  const { data: placements = [] } = manageAppsAPI.useGetPlacementsQuery(pba_id);

  const text$ = useSignal('');
  const placementNameIsUnique$ = useComputed(() => {
    const currentName = text$.value.trim().toLowerCase();
    if (!currentName) return true;

    const usedNames = placements
      .filter((item) => item.status !== '9')
      .map((item) => (item.name || '').trim().toLowerCase())
      .filter(Boolean);

    return !usedNames.includes(currentName);
  });
  const errorFlag$ = useComputed(() => {
    return text$.value.length > NAME_CHAR_LIMIT || !placementNameIsUnique$.value;
  });

  const disableSaveButton$ = useComputed(() => {
    if (!text$.value.trim()) return true;
    if (text$.value.length > NAME_CHAR_LIMIT) return true;
    if (!placementNameIsUnique$.value) return true;
    return false;
  });

  const handleCreatePlacement = () => {
    if (disableSaveButton$.value) return;
    createPlacement({ data: { name: text$.value.trim() }, pba_id });
    close();
  };

  const handleChangeName = (e) => {
    text$.value = e.target.value;
  };

  return (
    <ModalBase>
      <S.Box>
        <ModalHeader title='Create Placement' close={close} />
        <S.Content>
          <S.Title>Name:</S.Title>
          <CustomInput
            containerStyle={{ height: '70px' }}
            autoComplete='off'
            name='createPlacementInput'
            id='createPlacementInput'
            value={text$.value}
            onChange={handleChangeName}
            error={errorFlag$.value}
            errorText={
              !placementNameIsUnique$.value
                ? 'Name must be unique'
                : `No more than ${NAME_CHAR_LIMIT} characters`
            }
          />
        </S.Content>
        <ModalFooter
          saveButtonText='Save Placement'
          saveButtonOnClick={handleCreatePlacement}
          close={close}
          saveButtonDisabled={disableSaveButton$.value}
        />
      </S.Box>
    </ModalBase>
  );
};

export default CreatePlacementModal;
